import React from 'react';
import './App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar  from './Navbar';
import Certification from './Certification';

import Home from './Home'; 

function App() {

  React.useEffect(() => {
    AOS.init({
  duration: 1000,
  easing: 'ease-in-out',
  once: false,
});

  }, []);
  
  return (
    <Router>
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/certification" element={<Certification />} />
    </Routes>
  </Router>
  );
}

export default App;
